import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { HeroDemo } from './HeroDemo';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-96">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.15] pointer-events-none" data-id="element-97" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-zinc-950 to-zinc-950 pointer-events-none" data-id="element-98" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-99">
        <div className="flex flex-col items-center text-center" data-id="element-100">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-xs font-mono text-zinc-300 mb-8" data-id="element-101">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500" data-id="element-102" />
            v2.0 — Now with Agent Mode <ArrowRight size={12} data-id="element-103" />
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-bold tracking-tight text-white max-w-4xl leading-[1.1]" data-id="element-104">
            The spreadsheet, <br className="hidden md:block" data-id="element-105" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-zinc-500" data-id="element-106">
              reinvented for AI.
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="mt-6 text-lg md:text-xl text-zinc-400 max-w-2xl" data-id="element-107">
            Sheets2Board turns natural language into formulas, charts, and
            dashboards. Stop fighting Excel — just describe what you need and
            watch it build.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mt-10 flex flex-col sm:flex-row items-center gap-4" data-id="element-108">
            <button className="w-full sm:w-auto px-6 py-3 bg-white text-zinc-950 rounded-md font-medium hover:bg-zinc-200 transition-colors flex items-center justify-center gap-2" data-id="element-109">
              Start for free
            </button>
            <button className="w-full sm:w-auto px-6 py-3 bg-transparent text-white border border-white/20 rounded-md font-medium hover:bg-white/5 transition-colors flex items-center justify-center gap-2" data-id="element-110">
              Book a demo <ArrowRight size={16} data-id="element-111" />
            </button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} data-id="element-112">
          <HeroDemo data-id="element-113" />
        </motion.div>
      </div>
    </section>;
}